import { Directive, ElementRef, HostListener, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { DetailViewActions } from '@ninety/platform/state';

/** web-maz-redesign: Esc and clicks outside close the Sheet, never Maz. */
@Directive({
  selector: '[ninetyMazSheet]',
  standalone: true,
})
export class MazSheetDirective {
  private store = inject(Store);
  private router = inject(Router);
  private host = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input({ alias: 'ninetyMazSheet', required: true }) open: boolean | null = false;

  private urlAtPointerDown: string | null = null;

  @HostListener('document:keydown.escape', ['$event'])
  protected closeOnEscape(event: Event): void {
    if (!this.open || event.defaultPrevented || hasOpenOverlay()) return;
    // Esc in a field cancels the edit, not the Sheet.
    if ((event.target as Element | null)?.closest('maz-copilot, input, textarea, [contenteditable]')) return;
    this.store.dispatch(DetailViewActions.close());
  }

  @HostListener('document:pointerdown', ['$event'])
  protected rememberUrl(event: PointerEvent): void {
    this.urlAtPointerDown = this.open && this.isOutside(event.target) ? this.router.url : null;
  }

  @HostListener('document:click', ['$event'])
  protected closeOnClickOutside(event: MouseEvent): void {
    const urlAtPointerDown = this.urlAtPointerDown;
    this.urlAtPointerDown = null;
    if (!urlAtPointerDown || !this.isOutside(event.target)) return;
    // A click that opened another item navigates; only close if it didn't.
    setTimeout(() => {
      if (!this.open || this.router.getCurrentNavigation() || this.router.url !== urlAtPointerDown) return;
      this.store.dispatch(DetailViewActions.close());
    });
  }

  private isOutside(target: EventTarget | null): boolean {
    const element = target as Element | null;
    if (!element?.isConnected || hasOpenOverlay()) return false;
    return !this.host.nativeElement.contains(element) && !element.closest('maz-copilot, .cdk-overlay-container');
  }
}

function hasOpenOverlay(): boolean {
  return !!document.querySelector(
    '.cdk-overlay-container .cdk-overlay-pane, .cdk-overlay-container .cdk-overlay-backdrop'
  );
}
